<template>
  <BaseCombobox
    class="unit-dropdown"
    :model-value="modelValue"
    :items="units"
    input-class="is-small"
    value-key="value"
    label-key="label"
    trigger-label-key="value"
    trigger-mode="button"
    :disabled="disabled"
    :button-class="['unit-dropdown-button', buttonClass]"
    :button-title="title"
    :button-placeholder="placeholder"
    embedded-menu
    id-prefix="unit-dropdown"
    @update:model-value="emit('update:modelValue', $event)"
    @select="handleSelect"
  >
    <template #option="{ option, selected }">
      <span>{{ option.value }}</span>
      <span class="is-flex is-align-items-center">
        <span v-if="option.label" class="has-text-grey is-size-7 ml-2">{{ option.label }}</span>
        <span v-if="selected" class="icon is-small has-text-success ml-2">
          <i class="fas fa-check"></i>
        </span>
      </span>
    </template>
  </BaseCombobox>
</template>

<script setup>
  import { computed, inject } from "vue";

  import BaseCombobox from "../shared/base-combobox.vue";

  const triggerSave = inject("triggerSave");

  const STANDARD_UNITS = [
    { value: "mg", label: "milligrams" },
    { value: "mcg", label: "micrograms" },
    { value: "g", label: "grams" },
    { value: "IU", label: "International Units" },
    { value: "oz", label: "ounces" },
    { value: "ml", label: "milliliters" },
    { value: "tbsp", label: "tablespoons" },
    { value: "tsp", label: "teaspoons" },
  ];

  const props = defineProps({
    modelValue: { type: String, default: "" },
    placeholder: { type: String, default: "mg" },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: "" },
    buttonClass: { type: [String, Object, Array], default: "" },
    allowedUnits: { type: Array, default: null },
  });

  const emit = defineEmits(["update:modelValue"]);

  // Build the list of units based on allowedUnits prop
  const units = computed(() => {
    if (props.allowedUnits && props.allowedUnits.length > 0) {
      return props.allowedUnits.map((u) => {
        const standard = STANDARD_UNITS.find((s) => s.value === u);
        return standard || { value: u, label: "" };
      });
    }
    return STANDARD_UNITS;
  });

  function handleSelect() {
    triggerSave?.();
  }
</script>

<style lang="scss" scoped>
  $field-height: 28px;

  .unit-dropdown {
    :deep(.unit-dropdown-button) {
      min-width: 60px;
      height: $field-height !important;
      min-height: $field-height !important;
      max-height: $field-height !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      line-height: $field-height !important;
      box-sizing: border-box !important;
      padding-left: 0.5em;
      padding-right: 0.5em;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    :deep(.unit-dropdown-button .icon) {
      margin-left: 0.25em;
    }

    :deep(.dropdown-menu) {
      min-width: 160px;
    }
  }
</style>
